/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { GetUpcomingAppointmentsApiArg, GetUpcomingAppointmentsApiResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUpcomingAppointments: build.query<GetUpcomingAppointmentsApiResponse, GetUpcomingAppointmentsApiArg>({
      query: (queryArg) => ({
        method: 'GET',
        params: {
          quantity: queryArg.quantity,
          type: queryArg['type'],
        },
        url: `/v1/appointments/upcoming`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getUpcomingAppointmentsApi };
export const { useGetUpcomingAppointmentsQuery, useLazyGetUpcomingAppointmentsQuery } = injectedRtkApi;
